import React, {useEffect, useState} from 'react';
import car1 from "../../imgs/car1.jpg"
import car2 from "../../imgs/car2.jpg"
import car3 from "../../imgs/car3.jpg"
import car4 from "../../imgs/car4.jpg"
import car5 from "../../imgs/car5.jpg"
import car6 from "../../imgs/car6.jpg"
import car7 from "../../imgs/car7.jpg"
import car8 from "../../imgs/car8.jpg"
import car9 from "../../imgs/car9.jpg"
import car10 from "../../imgs/car10.jpg"
import car11 from "../../imgs/car11.webp"
import styles from "./slider.module.css"
import {useTranslation} from "react-i18next";

const Slider = () => {
    const {t} = useTranslation()
    const slogans = t("hero.slogans", {returnObjects: true}) as string[]
    const imgArr = [car1, car2, car3, car4, car5, car6, car7, car8, car9, car10, car11]
    // Единый счётчик: картинки (7) и лозунги (их может быть больше) крутятся
    // независимо, чтобы показывались ВСЕ лозунги, а не только первые 7.
    const [tick, setTick] = useState(0)
    const [visible, setVisible] = useState(true)

    useEffect(() => {
        const timer = setInterval(() => {
            setVisible(false)
            setTimeout(() => {
                setTick(prev => prev + 1)
                setVisible(true)
            }, 400)
        }, 5000)
        return () => clearInterval(timer)
    }, [])

    const activeImgIndex = tick % imgArr.length
    const slogan = Array.isArray(slogans) && slogans.length
        ? slogans[tick % slogans.length]
        : ""

    return (
        <div className="app_container">
            <div className={styles.slider_container}>
                <img className={styles.bg_img} src={imgArr[activeImgIndex]} alt="" />
                <div className={styles.gradient} />
                <div className={styles.hero_content}>
                    <h1 className={`${styles.hero_slogan} ${visible ? styles.slogan_visible : styles.slogan_hidden}`}>
                        {slogan}
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default Slider;
